import { render, staticRenderFns } from "./exhibition-car-yes.vue?vue&type=template&id=130228d8&scoped=true&"
import script from "./exhibition-car-yes.vue?vue&type=script&lang=js&"
export * from "./exhibition-car-yes.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-car-yes.vue?vue&type=style&index=0&id=130228d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130228d8",
  null
  
)

export default component.exports